import React from 'react';
import Divider from '../components/Divider';

export default class Quality extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className="container">
                <Divider marginBotoom={70} />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            STAP<span className="accent-color">MEDIF</span>,
                            votre centre d’appel spécialisé, l’expertise en plus
                        </h2>
                    </div>
                    <p>
                        Acteur engagé auprès des professionnels de l’
                        <b>imagerie médicale</b>, <b>STAPMEDIF</b> tisse avec
                        ses clients et partenaires un lien fort. Notre
                        conformité RGPD assure la sécurité de vos données de
                        santé.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">Nos points forts</h2>
                    </div>
                    <div className="shortcode-simple-list icon">
                        <ul>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                La garantie d’un décrochage rapide, sans mise en
                                attente ni perte d’appels
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Des secrétaires médicales qualifiées qui
                                connaissent parfaitement votre activité :
                                radiologie, échographie, mammographie,
                                densitométrie, IRM, scanner.
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Un accueil téléphonique professionnel et
                                souriant à l’image de votre centre
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                L’accompagnement d’une référente dédiée
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Un reporting détaillé chaque mois
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Une offre 100% française, sans sous-traitance ni
                                externalisation hors métropole
                            </li>
                        </ul>
                    </div>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Performance et fiabilité pour votre secrétariat
                            médical externalisé
                        </h2>
                    </div>
                    <p>
                        Nous avons fait le choix d’équipements de dernière
                        génération, combinant qualité, fiabilité et sécurité.
                        Notre secrétariat traite plus de 6 000 appels par jour.
                        Plusieurs niveaux de secours garantissent la continuité
                        et la disponibilité de votre secrétariat externalisé en
                        toutes circonstances. Tous les appels sont enregistrés
                        et peuvent vous être fournis sur simple demande. Vos
                        données sont traitées dans la plus stricte
                        confidentialité et demeurent votre propriété dans le
                        respect du RGPD.
                    </p>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            L’externalisation de votre prise de rendez-vous :
                            plus qu’un service, une valeur ajoutée
                        </h2>
                    </div>
                    <div className="shortcode-simple-list icon">
                        <ul>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Une permanence téléphonique assurée sur une
                                large amplitude
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Une optimisation de vos vacations grâce à la
                                diminution des plages vides et rendez-vous non
                                honorés
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                L’assurance d’un budget maitrisé, sans
                                recrutement ni investissement d’infrastructure
                            </li>
                            <li>
                                <i className="accent-color fa fa-hand-o-right"></i>
                                Une image valorisée auprès de vos patients
                            </li>
                        </ul>
                    </div>
                </div>
                <Divider type="5" />
                <div>
                    <div
                        className="big-title animated fadeInDown delay-01"
                        data-animation="fadeInDown"
                        data-animation-delay="01"
                    >
                        <h2 className="iwh-title">
                            Notre meilleur argument : la satisfaction de nos
                            clients
                        </h2>
                    </div>
                    <p>
                        Chez <b>STAPMEDIF</b>, la satisfaction de nos clients
                        n’est pas un vain mot. C’est une ambition partagée au
                        quotidien par toute une équipe. Nos engagements et nos
                        résultats, ce sont nos clients qui en parlent le mieux.
                        Vous voulez en avoir le cœur net ? Sur demande, nous
                        vous mettons en relation avec des{' '}
                        <b>centres d’imagerie médicale</b> qui nous font
                        confiance. Contactez-nous.
                    </p>
                </div>
                <Divider />
            </div>
        );
    }
}

Quality.propTypes = {};



// WEBPACK FOOTER //
// ./src/routes/Quality.jsx